import React from 'react';

export function DirectOrderShippingNote({ t, note, onChange }) {
  return (
    <>
      <p className="text-[12px] font-medium text-[#0f172a] mb-2">{t('Note from MedEffects')}</p>
      <textarea
        aria-label={t('Note from MedEffects')}
        value={note}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t('Add a note...')}
        className="w-full h-[80px] border border-[#e2e8f0] rounded-[10px] px-4 py-3 text-xs text-[#0f172a] placeholder:text-[#97a3b6] resize-none focus:outline-none focus:ring-2 focus:ring-[#0089ff]/20 focus:border-[#0089ff] mb-5"
      />
    </>
  );
}

export function DirectOrderCancelButton({ t, onCancel, disabled }) {
  return (
    <button
      onClick={onCancel}
      disabled={disabled}
      className="h-[42px] px-5 bg-[#f23e41] text-white text-sm font-semibold rounded-[10px] hover:bg-[#d93235] transition-colors disabled:opacity-50"
    >
      {t('Cancel Order')}
    </button>
  );
}
